<template>
  <div class="terms">
    <v-flex class="mb-3">
      <v-btn class="mx-0" color="#0C2B4A" dark @click="htmlToPaper('print')">Print</v-btn>
    </v-flex>
    <div id="print">
      <div v-if="mersBranded">
        <mersTerms />
      </div>
      <div v-else>
        <terms />
      </div>
    </div>
  </div>
</template>
<script>
import VueHtmlToPaper from "@/plugins/print";
import Terms from "@/components/Terms.vue";
import MersTerms from "@/components/MersTerms.vue";
import { mapState } from "vuex";
export default {
  name: "termsPage",
  components: {
    Terms,
    MersTerms
  },
  mixins: [VueHtmlToPaper],
  methods: {},
  computed: {
    ...mapState("user", [
      "retirementBranded",
      "retirementBrandedTitle",
      "mersBranded",
      "mersBrandedTitle",
      "step"
    ])
  }
};
</script>
<style lang="scss" scoped>
button.v-btn__content {
  text-transform: capitalize;
}
.mers {
  button {
    background-color: #33715a !important;
    &:active {
      background-color: #33715a !important;
    }
  }
}
</style>
